/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import PropTypes from 'prop-types';
import SvgIcon from '@material-ui/core/SvgIcon';

const FuneralHome = (props) => {
    const { className } = props;
    return (
        <SvgIcon className={className} viewBox="0 0 38 47" fill="none">
            <path
                d="M3.68262 8.00357L3.13558 7.52165L2.95358 7.72824V8.00357V44.025V44.754H3.68262H34.1872H34.9162V44.025V8.00357V7.72824L34.7342 7.52165L34.1872 8.00357C34.7342 7.52165 34.734 7.52138 34.7337 7.52108L34.7331 7.52037L34.7315 7.51855L34.7268 7.51328L34.7115 7.49634C34.6987 7.48226 34.6807 7.46265 34.6575 7.43787C34.6111 7.38833 34.5439 7.31812 34.4561 7.23022C34.2804 7.05446 34.0219 6.80772 33.6817 6.51383C33.0016 5.92627 31.993 5.14855 30.6652 4.37239C28.0077 2.81895 24.0689 1.27096 18.9349 1.27096C13.8009 1.27096 9.86212 2.81895 7.20458 4.37239C5.87676 5.14855 4.86822 5.92627 4.18809 6.51383C3.84789 6.80772 3.58938 7.05446 3.4137 7.23022C3.32584 7.31812 3.25865 7.38833 3.21226 7.43787C3.18907 7.46265 3.17107 7.48226 3.15828 7.49634L3.14302 7.51328L3.13832 7.51855L3.1367 7.52037L3.13608 7.52108C3.13582 7.52138 3.13558 7.52165 3.68262 8.00357Z"
                fill="currentColor"
                stroke="white"
                strokeWidth="1.45808"
            />
            <rect
                y="36.4663"
                width="37.8677"
                height="7.55824"
                fill="currentColor"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M24.2241 22.8548C23.6862 24.9377 22.8109 26.7948 21.1095 27.7618C20.6798 27.9415 20.2031 28.0248 19.7091 27.8598C18.6833 24.6889 19.4266 20.9455 20.8831 18.1997C21.9011 16.0832 23.6078 14.617 25.539 13.4842C23.8824 16.244 25.1361 19.7979 24.2241 22.8548"
                fill="white"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M21.0596 15.939C18.62 18.6843 16.5921 23.4987 17.8082 27.8001C16.2569 27.4318 15.0962 25.5581 14.5806 23.6393C14.1376 21.6678 14.3646 19.4586 15.4828 17.9977C16.7297 16.1941 18.1398 13.9976 17.8021 11.3512C19.408 11.9541 20.4681 14.0255 21.0596 15.939"
                fill="white"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M18.4848 27.2762C18.3451 27.2357 18.2159 27.3451 18.2229 27.445C17.385 29.8119 16.6064 32.3754 16.1909 34.9135C15.3354 32.4643 14.2565 30.0809 12.9612 27.8631C10.4647 23.4712 7.7936 19.1919 4.10302 16.6399C3.95986 16.5495 3.82369 16.559 3.74339 16.7152C3.66308 16.8714 3.72244 17.0679 3.8237 17.2114C7.22798 20.2351 9.16233 25.0677 11.5506 29.2163C13.5303 34.0457 15.4856 39.178 15.3704 44.7059C15.5311 45.6983 16.2643 46.3998 17.0254 46.196C17.3397 46.1238 17.5981 45.9051 17.8076 45.6395C18.0136 45.324 18.1253 44.9649 18.1427 44.5623C17.6958 42.7368 17.4304 40.8987 17.392 39.0447C17.3222 37.3936 17.4339 35.7298 17.6853 34.1065C18.0344 31.9243 18.614 29.7762 18.6838 27.5131C18.6803 27.4632 18.5791 27.3197 18.4848 27.2762"
                fill="white"
            />

        </SvgIcon>
    );
};

FuneralHome.defaultProps = { className: '' };

FuneralHome.propTypes = { className: PropTypes.string };

export default FuneralHome;
